import React from 'react';
import { Box, Typography } from '@mui/material';
import { BRAND } from '../../theme/brandTokens';

const StoreSelectorTrigger = ({
  currentStore,
  onClick,
  storeSelectable = true,
  fallbackLabel = 'Loading...',
  typographyVariant = 'h6',
  logoUrl,
  sx,
}) => {
  const interactiveProps = storeSelectable
    ? {
        component: 'button',
        type: 'button',
        onClick,
      }
    : {};

  return (
    <Box
      {...interactiveProps}
      title={currentStore?.name || undefined}
      sx={{
        display: 'flex',
        alignItems: 'center',
        flex: '0 1 auto',
        minWidth: 0,
        maxWidth: { xs: '100%', lg: 'min(100%, 40vw, 420px)' },
        overflow: 'hidden',
        p: 0,
        border: 'none',
        background: 'none',
        boxShadow: 'none',
        textAlign: 'left',
        font: 'inherit',
        cursor: storeSelectable ? 'pointer' : 'default',
        ...sx,
      }}
    >
      {logoUrl ? (
        <Box
          component="img"
          src={logoUrl}
          alt={currentStore?.name || fallbackLabel}
          sx={{
            display: 'block',
            width: 'auto',
            maxWidth: { xs: 190, lg: 300 },
            height: { xs: 40, lg: 44 },
            objectFit: 'contain',
            objectPosition: 'left center',
          }}
        />
      ) : (
        <Typography
          variant={typographyVariant}
          noWrap
          sx={{
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontWeight: 600,
            color: BRAND.primaryText,
            transition: 'color 0.2s ease',
            '&:hover': storeSelectable
              ? {
                  color: BRAND.accentText,
                }
              : undefined,
          }}
        >
          {currentStore?.name || fallbackLabel}
        </Typography>
      )}
    </Box>
  );
};

export default StoreSelectorTrigger;